import { WorkspaceActionsProps } from './WorkspaceActions';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import { createSearchParams, useSearchParams } from 'react-router-dom';
import useAlarmsByWorkspace from '../../../../../redux/alarm/hooks/useAlarmsByWorkspace';
import { ErrorIcon } from '../../../../../assets';

export function WorkspaceAlarmsAction(props: WorkspaceActionsProps) {
  const { workspace, active } = props;
  const { data: alarmsData, isLoading: isLoadingAlarmsData } =
    useAlarmsByWorkspace(workspace?.id, {
      skip: !workspace?.id,
    });
  const [searchBarParams] = useSearchParams();
  const searchParamsObject = Object.fromEntries(searchBarParams.entries());
  if ((alarmsData?.length === 0 || !alarmsData) && !isLoadingAlarmsData) {
    return null;
  }

  if (isLoadingAlarmsData) {
    return (
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'center'}
        margin={'0.5rem'}
      >
        <CircularProgress size={24} />
      </Stack>
    );
  }

  return (
    <Button
      variant={active ? 'contained' : 'outlined'}
      color={active ? 'primary' : 'inherit'}
      loading={isLoadingAlarmsData}
      href={`/markets/${workspace?.id}/view-locations?${createSearchParams({
        ...searchParamsObject,
        alarmsActive: !active + '',
      }).toString()}`}
      sx={{
        fontSize: '1rem',
        width: '6rem',
        height: '3rem',
      }}
    >
      <Stack direction={'row'} spacing={0.5}>
        <Typography
          component="span"
          variant={'inherit'}
          color={!active ? 'error' : 'inherit'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <ErrorIcon height={'1.5em'} />
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          fontSize={'1rem'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          |
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          display={'flex'}
          alignItems={'center'}
          fontSize={'1rem'}
          justifyContent={'center'}
        >
          {alarmsData?.length}
        </Typography>
      </Stack>
    </Button>
  );
}
